import { __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { NumericFormat } from 'react-number-format';
import { sendInputEvent } from '../../utils';
const toNumberInputProps = (numberFormat) => {
    const parts = Object.fromEntries(numberFormat.formatToParts(1000.22).map(({ type, value }) => [type, value]));
    return {
        displayType: 'input',
        decimalSeparator: parts.decimal,
        thousandSeparator: parts.group,
        thousandsGroupStyle: 'thousand',
    };
};
export function NumberInput(props) {
    const { numberFormat, className, placeholder, value, readOnly, disabled, onChange, onBlur, onFocus, getInputRef } = props, inputProps = __rest(props, ["numberFormat", "className", "placeholder", "value", "readOnly", "disabled", "onChange", "onBlur", "onFocus", "getInputRef"]);
    const hiddenInput = useRef(null);
    const onValueChange = ({ value }) => {
        if (hiddenInput.current)
            sendInputEvent(hiddenInput.current, value);
    };
    const numberFormatProps = Object.assign(Object.assign({}, toNumberInputProps(numberFormat)), { className,
        value,
        onValueChange,
        placeholder,
        onBlur,
        onFocus,
        getInputRef,
        readOnly,
        disabled });
    const hiddenInputProps = Object.assign(Object.assign({}, inputProps), { ref: hiddenInput, type: 'hidden', defaultValue: value, onInput: onChange });
    return (_jsxs(_Fragment, { children: [_jsx("input", Object.assign({}, hiddenInputProps)), _jsx(NumericFormat, Object.assign({ valueIsNumericString: true, displayType: "input" }, numberFormatProps))] }));
}
//# sourceMappingURL=NumberInput.js.map